import { Directive, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appExternalLink]',
})
export class ExternalLinkConfirmDirective {
  private readonly router = inject(Router);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Find closest anchor tag
    const anchor = target.closest('a') as HTMLAnchorElement;
    if (!anchor || !anchor.href) return;

    const isExternal = !anchor.href.includes(window.location.hostname);

    if (isExternal) {
      event.preventDefault();

      const confirmed = window.confirm('Möchtest du den externen Link öffnen?');

      if (confirmed) {
        window.open(anchor.href, '_blank');
      }
      return;
    }

    // Route internal links through the Angular router instead of a full
    // browser navigation, since the hosting environment does not reliably
    // fall back deep links to index.html.
    event.preventDefault();
    this.router.navigateByUrl(anchor.pathname + anchor.search + anchor.hash);
  }
}